import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { computed, ref } from 'vue';

export type ButtonStyle =
  | 'btn-primary'
  | 'btn-triadic'
  | 'btn-triadic-half'
  | 'btn-success'
  | 'btn-warning'
  | 'btn-dark'
  | 'btn-default'
  | 'btn-info'
  | 'btn-cancel'
  | 'btn-secondary' // ここから以下2024/03/19 更新・追加
  | 'btn-disabled'
  | 'btn-error'
  | 'btn-secondary-error'
  | 'btn-secondary'
  | 'btn-disabled-error'
  | 'btn-tertiary';

declare type ClickFunc = (args?: any) => any;

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'Btn',
  props: {
    onClick: {},
    typography: { default: '' },
    buttonStyle: { default: 'btn-default' },
    disabled: { type: Boolean, default: false },
    toolTipValue: { default: '' },
    eventModifier: { default: '' }
  },
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "3848f0e4": (props.disabled ? `not-allowed` : `pointer`),
  "0416210c": (props.disabled ? `none` : `0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)`),
  "56438082": (props.disabled ? 0.6 : 1)
}))

const props = __props;

// 変数
const el = ref<HTMLButtonElement | null>(null);

// ボタンのフォーカスを公開
__expose({
  focus: () => el.value?.focus(),
});

// computed
const buttonClasses = computed(() => {
  const classList = ['inline-block', props.buttonStyle, props.typography];
  return classList.filter((item) => item).join(' ');
});

// script
const handleClickButton = (event: MouseEvent) => {
  props.onClick(event);
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.eventModifier === 'stop')
    ? _withDirectives((_openBlock(), _createElementBlock("button", {
        key: 0,
        ref_key: "el",
        ref: el,
        class: _normalizeClass([buttonClasses.value, "button_content"]),
        disabled: _ctx.disabled,
        onClick: _withModifiers(handleClickButton, ["stop"])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1)), [
        [_directive_tooltip, _ctx.toolTipValue]
      ])
    : (_ctx.eventModifier === 'prevent')
      ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 1,
          ref_key: "el",
          ref: el,
          class: _normalizeClass([buttonClasses.value, "button_content"]),
          disabled: _ctx.disabled,
          onClick: _withModifiers(handleClickButton, ["prevent"])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_2)), [
          [_directive_tooltip, _ctx.toolTipValue]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 2,
          ref_key: "el",
          ref: el,
          class: _normalizeClass([buttonClasses.value, "button_content"]),
          disabled: _ctx.disabled,
          onClick: _withModifiers(handleClickButton, ["stop"])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_3)), [
          [_directive_tooltip, _ctx.toolTipValue]
        ])
}
}

})